/**
 * Takes a DOM element and recursively traverses it to build up a string containing the text value from
 * each text node, separated by a delimiter.
 *
 * @param element Link element to traverse.
 * @param delimiterString String used to separate each text node
 * @returns string The text value of each text node, separated by a delimiter.
 */
const getAllDescendantTextNodeValues = (
	element,
	delimiterString = ' | ',
	win
) => {
	let result = '';

	(function findTextNodes(current) {
		for (let i = 0; i < current.childNodes.length; i++) {
			const child = current.childNodes[i];
			const isTextNode = child.nodeType === 3;
			const isString = typeof child.nodeValue === 'string';
			const isEmptyString = isString && child.nodeValue.trim() === '';
			const isNewLineCharacter =
				isString &&
				child.nodeValue.length === 1 &&
				child.nodeValue.indexOf('\n') !== -1;
			/**
			 * Retrieve text of base element regardless of visibility.
			 * Handles scenario where clicked button is then hidden.
			 */
			const isHiddenText =
				child.parentNode !== element &&
				((typeof child.parentNode.className === 'string' &&
					child.parentNode.className.indexOf('hide') > -1) ||
					win
						.getComputedStyle(child.parentNode)
						.getPropertyValue('visibility') === 'hidden' ||
					win
						.getComputedStyle(child.parentNode)
						.getPropertyValue('display') === 'none');

			if (
				isTextNode &&
				!isEmptyString &&
				!isNewLineCharacter &&
				!isHiddenText
			) {
				result += child.nodeValue.trim() + delimiterString;
			} else {
				findTextNodes(child);
			}
		}
	})(element);

	return result.slice(0, -delimiterString.length);
};

export default getAllDescendantTextNodeValues;
